<template>
    <Head>
        <title>Фиатные шлюзы организации</title>
    </Head>


    <authenticated-layout :notifications="notifications" >
        <v-navigation :organization-id="organizationId"/>
        <div class="flex flex-col bg-white">
            <form
                class="grid grid-cols-5 p-2 gap-4 items-center"
                @submit.prevent="create"
            >
                <v-toggle v-model="add.isActive" label="Активен"/>
                <v-select label="Реквизиты" v-model="add.credentialsId" :error="errors.credentialsId">
                    <option v-for="cred in credentials" :value="cred.id">{{cred.name}}</option>
                </v-select>
                <v-input-json label="Настройки" class="col-span-2" v-model="add.settings" :error="errors.settings" />
                <v-button>Добавить</v-button>
            </form>
            <div class="grid grid-cols-5 border-t p-2 gap-4 font-bold" v-if="success">
                <span>Активен</span><span>Реквизиты</span><span>Настройки</span>
            </div>
            <div class="grid grid-cols-5 border-t p-2 gap-4 items-center" v-for="row in result" v-if="success">
                <v-toggle v-model="row.isActive" @change="changeActive(row)"/>
                <div>{{ row.credentials.name }}</div>
                <v-input-json label="Настройки" class="col-span-2" v-model="row.settings" @input="row.settingUpdate = true"/>
                <div class="flex flex-col gap-2">
                    <div class="text-sm flex flex-row gap-2">
                        <strong>Баланс:</strong>
                        <span v-if="row.balance">
                            {{ row.balance.Amount }}
                            {{ row.balance.Currency.ticker }}
                        </span>
                    </div>
                    <v-button :disabled="!row.settingUpdate" @click="changeSetting(row)">Обновить настройки</v-button>
                </div>
            </div>
        </div>
    </authenticated-layout>
</template>

<script>

import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VNavigation from '@/Components/Navigation/Organization';
import VToggle from '@/Components/Toggle';
import VInput from '@/Components/Input';
import VSelect from '@/Components/Select';
import VButton from '@/Components/Button';
import VInputJson from "@/Components/InputJson.vue";

export default {
    components: {
        VInputJson,
        Head, Link,
        AuthenticatedLayout,
        VNavigation,
        VToggle,
        VInput,
        VSelect,
        VButton,
    },
    props: {
        success: Boolean,
        result: Object,
        organizationId: String,
        notifications: Array,
        controllers: Object,
        errors: Object,
        credentials: Object,
    },
    data() {
        return {
            add: {
                credentialsId: '',
                isActive: false,
                settings: {
                    exchangeCommissionAmount: '0',
                    internalCommissionPercent: '2',
                    minInternalCommissionAmount: '0',
                },
            },
        };
    },
    mounted() {
        this.add.credentialsId = this.credentials[0].id;

        const {route, result, notifications} = this;
        for (const resultElement of result) {
            axios.get(route('organization.fiat.balance', resultElement.id))
                .then((res) => {
                    const {data} = res;
                    if(data.success) {
                        resultElement.balance = data.result;
                    } else if(data.notifications && data.notifications.length) {
                        notifications.concat(data.notifications);
                    }
                }).catch(err => console.log("Axios err: ", err))
        }
    },
    methods: {
        create() {
            const {add, notifications, organizationId} = this;
            notifications.push({
                type: 'success',
                title: 'Добавление шлюза',
                message: 'Отправка данных...',
                timeout: false,
            });
            useForm({
                isActive: add.isActive,
                credentialsId: add.credentialsId,
                settings: JSON.stringify(add.settings),
            }).post(this.route('organization.fiat.create', organizationId));
        },
        changeActive(r) {
            const {notifications} = this;
            notifications.push({
                type: 'success',
                title: r.isActive ? 'Включение шлюза' : 'Отключение шлюза',
                message: 'Отправка данных...',
                timeout: false,
            });
            useForm({
                isActive: r.isActive,
            }).post(this.route('organization.fiat.set.active', r.id));
        },
        changeSetting(r) {
            r.settingUpdate = false;
            const {notifications} = this;
            notifications.push({
                type: 'success',
                title: 'Обновление настроек шлюза для организации',
                message: 'Отправка данных...',
                timeout: false,
            });
            useForm({
                settings: JSON.stringify(r.settings),
            }).post(this.route('organization.fiat.set.settings', r.id));
        }
    },
};
</script>
